async function loadSDK (platform) {
  if (IS_BROWSER) {
    return new Promise(resolve => {
      const script = document.createElement('script')

      script.src = '/api/consultus/v1/sdk.js?factory-name=consultusSDK'
      script.async = true
      script.defer = true
      script.onload = () => {
        const consultus = window.consultusSDK()
        consultus.prefix = '/api/consultus/v1'
        resolve(consultus)
      }

      document.body.appendChild(script)
    })
  }

  const res = await platform.fetch(`https://${platform.router.host}/api/consultus/v1/sdk.js?factory-name=consultusSDK&global-name=consultusSDK`)
  const text = await res.text()

  // eslint-disable-next-line no-new-func
  const fn = new Function(text)

  fn()

  if (!global.consultusSDK) {
    return null
  }

  const sdk = global.consultusSDK({ fetch: platform.fetch, host: `https://${platform.router.host}` })

  sdk.prefix = '/api/consultus/v1'

  return sdk
}

export async function main (platform) {
  const sdk = await loadSDK(platform)

  platform.consultus = sdk
}
